import { render } from "./portal-notification.vue?vue&type=template&id=eab3c646&ts=true"
import script from "./portal-notification.vue?vue&type=script&lang=ts"
export * from "./portal-notification.vue?vue&type=script&lang=ts"

import "./portal-notification.vue?vue&type=style&index=0&id=eab3c646&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__